var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m8.5 5.5h17c0.8 0 1.5 0.7 1.5 1.5v33h-20v-33c0-0.8 0.7-1.5 1.5-1.5z",
  fill: "#c7d3dc"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 9.8,
  y: 8.2,
  width: 7.1,
  height: 31.8,
  fill: "#5a7d9a"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 17.3,
  y: 8.2,
  width: 7.1,
  height: 31.8,
  fill: "#5a7d9a"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 10.9,
  y: 9.4,
  width: 4.9,
  height: 29.4,
  fill: "#aecfdf"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 18.4,
  y: 9.4,
  width: 4.9,
  height: 29.4,
  fill: "#aecfdf"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m10.9 17.8 4.9-4.9v2.8l-4.9 4.9z",
  fill: "#dcebf3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m10.9 23.4 4.9-4.9v1.5l-4.9 4.9z",
  fill: "#dcebf3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m18.4 17.8 4.9-4.9v2.8l-4.9 4.9z",
  fill: "#dcebf3"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m18.4 23.4 4.9-4.9v1.5l-4.9 4.9z",
  fill: "#dcebf3"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 14.9,
  y: 16.5,
  width: 1.5,
  height: 14.5,
  rx: 0.75,
  fill: "#3f4a54"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 17.6,
  y: 16.5,
  width: 1.5,
  height: 14.5,
  rx: 0.75,
  fill: "#3f4a54"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 30.5,
  y: 15.5,
  width: 9,
  height: 14,
  rx: 1.6,
  fill: "#3f4a54"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 19,
  r: 1.4,
  fill: "#e05c4b"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 32.4,
  y: 22.4,
  width: 5.2,
  height: 1.4,
  rx: 0.7,
  fill: "#8fa0ad"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 32.4,
  y: 25.2,
  width: 5.2,
  height: 1.4,
  rx: 0.7,
  fill: "#8fa0ad"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-14 34 34.5)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 28.5,
  y: 31,
  width: 11,
  height: 7,
  rx: 1.2,
  fill: "#eef3f6"
}), /*#__PURE__*/React.createElement("rect", {
  x: 28.5,
  y: 32.6,
  width: 11,
  height: 1.8,
  fill: "#5a7d9a"
}), /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 35.6,
  width: 4.2,
  height: 1.1,
  rx: 0.55,
  fill: "#c7d3dc"
}));

function SvgCardReaderDoorIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardReaderDoorIssue);
export default __webpack_public_path__ + "static/media/card-reader-door-issue.e650382937b6961cfad5bf61d8077d47.svg";
export { ForwardRef as ReactComponent };